import { get } from '@uipath/portal-shell-util';

import { AuthSettings } from '../../constants/constants';
import { Account } from '../../models/account';
import { SessionSettings } from '../../models/SessionSettings';
import { caseInsensitiveCompare } from '../helper';
import Logger from '../logger/logger';
import { getOrganizationStandardUrl } from '../orgStandardUrlHelper';
import { sessionStore } from '../session/sessionStore';

export async function getSessionSettings(token: string, isMSI: boolean): Promise<SessionSettings> {
    const sessionSettingsUrl = `${getOrganizationStandardUrl()}/${isMSI ? 'identity/api' : 'portal_/api/identity'}/Setting?key=${AuthSettings.IdleTimeoutDuration}&key=${AuthSettings.AllowConcurrentBrowserSessions}&partitionGlobalId=${sessionStore.get('organizationId')}`;

    Logger.debug([ 'api', 'msi' ], 'fetching session settings');
    const sessionSettings: Array<{ key: string; value: string }> | undefined = await get(
        sessionSettingsUrl,
        { token },
        (e, method, url, requestProps) => {
            Logger.error([ 'api', 'msi' ], `unexpected error happened on session settings API call: ${e}, ${e.stack}`, {
                object: {
                    method,
                    error: e,
                    url,
                    requestProps,
                    hasToken: !!token,
                },
                stack: e.stack,
            });
        },
    );

    const idleSessionTimeoutPeriod = sessionSettings?.find(
        (setting) => caseInsensitiveCompare(setting.key, AuthSettings.IdleTimeoutDuration),
    )?.value;
    const allowConcurrentBrowserSessions = sessionSettings?.find(
        setting => caseInsensitiveCompare(setting.key, AuthSettings.AllowConcurrentBrowserSessions),
    )?.value ?? 'true';

    return {
        idleSessionTimeoutPeriod: Math.min(
            // if this is not a number, it will return NaN
            Number(idleSessionTimeoutPeriod), 24 * 60 * 60 * 1000,
        ) || undefined,
        allowConcurrentSessions: allowConcurrentBrowserSessions,
    };
}

export async function getAccount(organizationStandardUrl: string, token: string): Promise<Account | undefined> {
    const accountUrl = `${organizationStandardUrl}/portal_/api/filtering/leftnav/tenantsAndOrganizationInfo`;

    Logger.debug('api', 'fetching account');
    return get(
        accountUrl,
        { token },
        (e, method, url, requestProps) => {
            Logger.warn('api', `unexpected error happened on Account API call: ${e}, ${e.stack}`, {
                object: {
                    method,
                    error: e,
                    url,
                    requestProps,
                    hasToken: !!token,
                },
                stack: e.stack,
            });
        },
    );
}
